export const config ={
    FACEBOOK_ACCOUNTID: '489527475541294',

};

